<template>
  <div
    ref="button"
    v-on:click="startRefresh"
    class="refresh-button"
  >
  </div>
</template>

<script>

let stopTimeOut

export default {
  data: () => ({
    refreshing: false
  }),
  props: {
  },
  methods: {
    startRefresh () {
      if (!this.refreshing) {
        this.refreshing = true
        void this.$refs.button.offsetWidth
        this.$refs.button.classList.add('run-animation')
        this.$emit('refresh', true, this.stopRefresh)
      }
    },
    stopRefresh () {
      clearTimeout(stopTimeOut)
      stopTimeOut = setTimeout(() => {
        this.refreshing = false
        this.$refs.button.classList.remove('run-animation')
      }, 500)
    }
  }
}
</script>
